import { createClient } from "@supabase/supabase-js"

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Create a placeholder client if credentials are missing
// This prevents the app from crashing before Supabase is configured
let supabase = null

if (supabaseUrl && supabaseAnonKey && !supabaseUrl.includes("your-supabase")) {
  supabase = createClient(supabaseUrl, supabaseAnonKey)
} else {
  console.warn(
    "Supabase credentials not configured. Admin panel will not work until you add valid REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to your .env file.",
  )
  // Create a mock client that returns empty results
  supabase = {
    from: () => ({
      select: () => Promise.resolve({ data: [], error: null }),
      update: () => Promise.resolve({ data: null, error: { message: "Supabase not configured" } }),
      eq: function() { return this },
      order: function() { return this },
      single: function() { return this },
    }),
    auth: {
      getSession: () => Promise.resolve({ data: { session: null } }),
      onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
      signInWithPassword: () => Promise.resolve({ error: { message: "Supabase not configured" } }),
      signOut: () => Promise.resolve({}),
    },
  }
}

export { supabase }
